export default {
  /**
   * The props to the CTitle component in the container's header slot.
   */
  titleProps: {
    type: Object,
    default: () => ({})
  },

  /**
   * The title that foes in the container's header slot.
   */
  title: {
    type: String,
    default: '',
  },

  /**
   * Whether to put the table inside a card component.
   */
  isCard: Boolean
}
